import ApiService from "../../../core/services/ApiService";
import { ENV } from "../../../config";
import { DEFAULT_FILTER_KEYS } from "../../../shared/utils/CommonConstants";
import { FilterKeyTypes } from "../../../shared/types/FilterKeys.types";
import { CoaFilterParams } from "../pages/CoaList/CoaList.types";

const CLIENT_ID = ENV.CLIENT_ID;

class CoaService extends ApiService {
  basePath: string = "/api";

  async getAllCOA<T>() {
    return this.makeRequest<T>(`${this.basePath}/coa`, { method: "get" });
  }

  async getAllCoA<T>(filterParams?: CoaFilterParams): Promise<T> {
    return this.makeRequest<T>(
      `${this.basePath}/v2/coa/template?client-id=${CLIENT_ID}`,
      {
        method: "post",
        data: filterParams || ({} as any),
        extractData: true,
      },
    );
  }

  async getCoA<T>(filterParams: CoaFilterParams): Promise<T> {
    return this.makeRequest<T>(`${this.basePath}/coa/template`, {
      method: "POST",
      data: filterParams as any,
      extractData: true,
    });
  }

  async coaFilter<T>(): Promise<T> {
    return this.makeRequest<T>(
      `${this.basePath}/coa-template/filter-options?client-id=${CLIENT_ID}`,
      {
        method: "get",
        extractData: true,
      },
    );
  }

  async createCoA<T>(templateName: string, file: File): Promise<T> {
    const formData = new FormData();
    formData.append("templateName", templateName);
    formData.append("file", file);
    return this.makeRequest<T>(`${this.basePath}/coa`, {
      method: "post",
      data: formData,
      extractData: true,
    });
  }

  async getCoaSheetData<T>(id: number) {
    return this.makeRequest<T>(`${this.basePath}/coa/${id}/template`, {
      method: "get",
    });
  }

  async getCoaTemplateData<T>(
    deliverableId: number,
    startIndex = 0,
    rowSize = 50,
    pageNumber?: string,
    filteredKeys: FilterKeyTypes = { ...DEFAULT_FILTER_KEYS },
  ) {
    return this.makeRequest<T>(
      `${this.basePath}/coa/${deliverableId}/template?start-index=${
        startIndex > 0 ? startIndex : 0
      }&row-size=${rowSize}&sheet-number=${pageNumber ?? ""}&key1=${
        filteredKeys.Key1
      }&key2=${filteredKeys.Key2}&key3=${filteredKeys.Key3}&key4=${
        filteredKeys.Key4
      }`,
      { method: "get" },
    );
  }

  async getCoaTemplateUsingAxios(deliverableId: number) {
    return this.makeRequest<ArrayBuffer>(
      `${this.basePath}/coa/${deliverableId}/template`,
      {
        method: "GET",
        responseType: "arraybuffer",
        extractData: true,
      },
    );
  }

  async importCoa<T>(id: string, file: File, startIndex: number = 0): Promise<T> {
    const formData = new FormData();
    formData.append("file", file);
    return this.makeRequest(
      `${this.basePath}/coa/${id}/template/version?start-index=${
        startIndex < 1 ? 0 : startIndex
      }`,
      {
        method: "post",
        data: formData,
        extractData: true,
      },
    );
  }

  async exportCoaAxios<T>(id: string): Promise<T> {
    return this.makeRequest<T>(`${this.basePath}/coa/${id}/export`, {
      responseType: "arraybuffer",
      extractData: true,
    });
  }
}

export default CoaService;
